import React, { useCallback, useState, useMemo } from "react";
import { Modal, Tag, Tooltip } from "antd";
import { SECURE_PASS_TAG_STATUS } from "@/utils/enum";
import SecurePassIcon from "@/components/SecurePass/SecurePassIcon/SecurePassIcon";
import { TAG_PROPS_MAP } from "@/components/SecurePass/SecurePassTag/constants";
import SecurePassText from "@/components/SecurePass/SecurePassText/SecurePassText";

const TOOL_TIP_OVERLAY_STYLE = { backgroundColor: "white" };

const SecurePassTag = ({ compact, tagStatus = SECURE_PASS_TAG_STATUS.Enabled }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onClickTag = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const onClickOkModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  const securePassTag = useMemo(
    () => TAG_PROPS_MAP[tagStatus] ?? TAG_PROPS_MAP[SECURE_PASS_TAG_STATUS.Disabled],
    [tagStatus],
  );

  return (
    <>
      <Tooltip title={securePassTag.toolTipText} overlayInnerStyle={TOOL_TIP_OVERLAY_STYLE}>
        <Tag color={securePassTag?.color} icon={<SecurePassIcon />} onClick={onClickTag} style={securePassTag.style}>
          {compact ? (
            <SecurePassText />
          ) : (
            <>
              <SecurePassText /> <span>{securePassTag.title}</span>
            </>
          )}
        </Tag>
      </Tooltip>

      <Modal
        visible={isModalVisible}
        title={
          <span>
            Autosled <SecurePassText bold />
          </span>
        }
        onOk={onClickOkModal}
        onCancel={onClickOkModal}
        cancelButtonProps={{ style: { display: "none" } }} // hide cancel button
      >
        <div>
          <SecurePassText bold /> adds an enhanced layer of security during the pickup process. Please see{" "}
          <a href="https://autosled.com/SecurePass" target="_blank" rel="noopener noreferrer">
            here
          </a>{" "}
          for more info.
        </div>
      </Modal>
    </>
  );
};

export default SecurePassTag;
